/**
 * Is this browser on a local development host?
 *
 * It gates the one override the shell still has: `?mfe=<key>=<url>`, which points a module at a
 * local `vite preview` instead of the built bundle (`spa/registry.ts`). That must never work on a
 * live domain — a query parameter that swaps a module out is a script-injection vector, and the
 * check is what keeps it a developer convenience rather than one.
 *
 * It used to gate two more, both gone with the tenant row (D118, PNK-121): `?tenantHost=`, which
 * chose which tenant a dev machine resolved as, and the DRAFT/PROVISIONING/FAILED statuses a dev
 * host was allowed to render ahead of a provisioner run.
 *
 * Pure — the caller passes `import.meta.env.DEV` — so it is testable without a `window` or a build.
 */
export function isDevHost(hostname: string, viteDev: boolean = false): boolean {
  return viteDev || hostname === "localhost" || hostname === "127.0.0.1";
}
